module.exports = __webpack_public_path__ + "img/Woodburn-Press-Logo-white.95d96283.png";